var Reverb = window.Reverb || {};
Reverb.BundledCheckout = Reverb.BundledCheckout || {};

Reverb.BundledCheckout.DiscountCodes = (function () {
  var thisContainer;

  var errorsContainerSelector = '[data-discount-code-errors-container]';
  var applyLinkSelector = 'a[data-discount-code-button]';
  var inputSelector = 'input[data-discount-code]';

  var urlDataAttribute = 'url';
  var paymentMethodDataAttribute = 'payment-method';

  function init(container) {
    thisContainer = container;
    bindFieldChange();
  }

  function bindFieldChange() {
    $(thisContainer).on('click', applyLinkSelector, applyDiscountCode);
    $(thisContainer).on('keydown', inputSelector, function (e) {
      if (e.keyCode == 13) {
        applyDiscountCode(e);
      }
    });
  }

  function applyDiscountCode(e) {
    e.preventDefault();

    var discountCode = $(inputSelector).val();
    if (discountCode.length === 0) {
      return;
    }

    var url = thisContainer.data(urlDataAttribute);
    var paymentMethod = thisContainer.data(paymentMethodDataAttribute);

    var request = $.ajax({
      url: url,
      type: 'POST',
      data: { discount_code: discountCode, payment_method: paymentMethod },
      dataType: 'json'
    });

    request.done(function (response, statusText, xhr) {
      var container = $(errorsContainerSelector);
      if (response.redirect) {
        window.location = response.redirect;
      } else {
        container.html(response.message);
      }
    });
  }

  function doUnlessJavascriptResponse(xhr, fn, context) {
    if (xhr.getResponseHeader('content-type').indexOf('javascript') === -1) {
      fn.call(context, xhr);
    }
  }

  return {
    init: init
  };
})();

$(() => {
  Reverb.BundledCheckout.DiscountCodes.init($('[data-discount-code-container]'));
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/bundled_checkout/discount_codes.js